<script>
import { mapActions, mapGetters } from 'vuex';
import ListItem from './components/ListItem';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'MaterialConfirmation',
  components: {
    ListItem,
  },
  mixins: [snackbarMixin],
  data() {
    return {
      hasError: false,
      isInitialized: false,
      isLoading: false,
      isSaving: false,
      itemList: [],
      selectedRows: [], // Array to store selected row IDs
      sortBy: 'Id',
      descending: true,
      search: '',
      selectedRecords: [],
    };
  },
  computed: {
    ...mapGetters('malzemeOnay', ['listHeaders']),
  },
  mounted() {
    this.initializeData();
  },
  methods: {
    ...mapActions('malzemeOnay', ['getList', 'reject', 'approve']),
    ...mapActions('app', ['showOverlay', 'hideOverlay']),

    fetchData() {
      this.isLoading = true;
      this.getList()
        .then((data) => {
          this.itemList = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    initializeData() {
      this.isLoading = true;
      Promise.all([this.getList()])
        .then(([prisonerResult]) => {
          this.itemList = prisonerResult.data;
          this.isInitialized = true;
          this.isLoading = false;
        }, () => {
          this.hasError = true;
          this.isLoading = false;
        });
    },
    rejectRecord(){	
      this.isLoading = true;	
      this.showOverlay();
      if (!this.selectedRecords || this.selectedRecords.length === 0) {
        this.showErrorMessage(`Lütfen en az 1 kayıt seçiniz.`);
        this.isLoading = false;	
        this.hideOverlay();
        return;
      }
      this.reject(this.selectedRecords.map(record => record.rowid))	
        .then(() => {	
          this.showSuccessMessage(`${this.selectedRecords.length} adet malzeme talebi reddedilmiştir.`);	
          this.selectedRecords = []
          this.fetchData();	
        })	
        .catch((err) => {	
          this.showErrorMessage(err.response && err.response.data);	
        })	
        .finally(() => {	
          this.isDeleting = false;
          this.isLoading = false;	
          this.hideOverlay();
        });	
    },	
    approveRecord() {	
      this.isDeleting = true;
      this.showOverlay();	
      if (!this.selectedRecords || this.selectedRecords.length === 0) {
        this.showErrorMessage(`Lütfen en az 1 kayıt seçiniz.`);
        this.isLoading = false;	
        this.hideOverlay();
        return;
      }
      this.approve(this.selectedRecords.map(record => record.rowid))	
        .then(() => {	
          this.showSuccessMessage(`${this.selectedRecords.length} adet malzeme talebi onaylanmıştır..`);	
          this.selectedRecords = []
          this.fetchData();	
        })	
        .catch((err) => {	
          this.showErrorMessage(err.response && err.response.data);	
        })	
        .finally(() => {	
          this.isDeleting = false;	
          this.isLoading = false;	
          this.hideOverlay()
        });	
    },
    closeDeleteDialog() {
      this.reactiveRejectDialogData.visible = false;
    },
    customFilter(value, search, item) {
      if (!search || search == '') {
        return true;
      }

      const searchStr = search.toString().toLowerCase().trim();

      return !!(
        // eslint-disable-next-line eqeqeq
        item.Id == searchStr
        || item.proje.toString().toLowerCase().trim().includes(searchStr)
        || item.aciklama.toString().toLowerCase().trim().includes(searchStr)
        || item.miktar.toString().toLowerCase().trim().includes(searchStr)
        || item.birim.toString().toLowerCase().trim().includes(searchStr)
        || item.malzeme.toString().toLowerCase().trim().includes(searchStr)
        || item.tur.toString().toLowerCase().trim().includes(searchStr)
        || item.siparisNo.toString().toLowerCase().trim().includes(searchStr)
        || item.tutar.toString().toLowerCase().trim().includes(searchStr)
        || item.doviz.toString().toLowerCase().trim().includes(searchStr)
      );
    },
  },
};
</script>

<template>
  <div>
    <template v-if="hasError">
      <p class="js-error-template ma-3">
        Malzeme Onay Talepleri listesinde bir hata oluştu. Lütfen tekrar deneyin!
      </p>
    </template>

    <template v-else>
      <v-toolbar dark dense color="#9FA8A3">
        <b> Malzeme Onay Talepleri </b>
        <v-spacer />
      </v-toolbar>

      <v-card>
        <v-card-title>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          v-model="selectedRecords"
          :headers="listHeaders"
          :items="itemList"
          :sort-by.sync="sortBy"
          :sort-desc.sync="descending"
          :search="search"
          :custom-filter="customFilter"
          class="elevation-1 spec-table"
          item-key="rowid"
          show-select
        >
          <template v-slot:top>
            {{ selectedRecords?selectedRecords.length:0 }} tane kayıt seçildi.

            <v-btn @click="rejectRecord()" color="darken-3" small icon fat text>
              <v-icon color="red">
                mdi-close
              </v-icon>
            </v-btn>
            <v-btn @click="approveRecord()" color="darken-3" small icon fat text>
              <v-icon color="success">
                mdi-check
              </v-icon>
            </v-btn>
          </template>

          <template slot="item" slot-scope="props">
            <list-item
              :item="props.item"
              :is-selected="props.isSelected"
              @select="props.select"
            />
          </template>
          <template slot="header.data-table-select" slot-scope="props">
            <v-checkbox
              :value="props.props.value"
              @change="props.on.input"
            />
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>
